import { CLOUD_PROVIDER } from "@/common/constants";
import { FirebaseConfig } from "./firebase";
import { SupabaseConfig } from "./supabase";

function getRTDBClient(name) {
  switch (name) {
    case CLOUD_PROVIDER.GCP:
      return new FirebaseConfig();

    case CLOUD_PROVIDER.AWS:
      return new SupabaseConfig();

    default:
      throw new Error(`Could not instantiate ${name}`);
  }
}

export let rtdbClient = getRTDBClient(CLOUD_PROVIDER.GCP);
